import React, { FC, lazy, Suspense } from 'react';
import {
  Navigate,
  Outlet,
  RouteObject,
  useSearchParams,
} from 'react-router-dom';
import { ActivityIndicator } from '@kontentino/ui';
import routeConfig from 'app/config/routes';
import SectionLayout from 'components/shared/SectionLayout';
import Container from 'app/components/Container';
import { createSearchFromParams } from 'utils/url';
import { isInAppNotificationFilter } from 'app/modules/inAppNotifications/components/NotificationsFeed';

type Props = {};
const NotificationsFeed = lazy(
  () => import('app/modules/inAppNotifications/components/NotificationsFeed'),
);

function NotificationsHistory() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const filter = searchParams.get('filter');

  return (
    <NotificationsFeed
      key={searchParams.toString()}
      initialTab={tab === 'collaboration' || tab === 'alerts' ? tab : undefined}
      initialFilter={isInAppNotificationFilter(filter) ? filter : undefined}
      onViewChange={(view) =>
        setSearchParams(createSearchFromParams(view), { replace: true })
      }
    />
  );
}

const InAppNotifications: FC<Props> = () => {
  return (
    <SectionLayout
      mainProps={{ className: '!tw-p-8' }}
      main={
        <Container className="tw-h-full">
          <Suspense
            fallback={
              <div className="tw-flex tw-h-full tw-items-center tw-justify-center">
                <ActivityIndicator />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </Container>
      }
    />
  );
};

export const inAppNotificationsRouter: RouteObject = {
  path: routeConfig.notifications.path,
  element: <InAppNotifications />,
  children: [
    {
      index: true,
      element: <Navigate to={routeConfig.notifications.routes.history.path} />,
    },
    {
      path: routeConfig.notifications.routes.history.path,
      element: <NotificationsHistory />,
    },
  ],
};
